export default function About() {
  return (
    <main className="max-w-2xl mx-auto py-16 px-4">
      <h1 className="text-3xl font-bold mb-4 text-gray-900">About HollerFinds</h1>
      <p className="text-lg text-gray-700">
        To reconnect communities through everyday generosity — by helping people list what they no longer need and discover what others are offering, all in their neighborhood.
      </p>
    </main>
  );
} 